import useFormState, { createFormValidation } from 'use-form-state';
import { useI18n } from '~/features/i18n';

type QuotationFormValues = {
    variantId: number | null;
    languageId: number | null;
};

const useQuotationCardFormState = (initialValues: Partial<QuotationFormValues>) => {
    const i18n = useI18n();
    const validation = createFormValidation<QuotationFormValues>([
        {
            path: 'variantId',
            validate: value => typeof value === 'number',
            message: i18n._('Variant is required'),
        },
        {
            path: 'languageId',
            validate: value => typeof value === 'number',
            message: i18n._('Language is required'),
        },
    ]);

    return useFormState<QuotationFormValues, QuotationFormValues>(
        {
            variantId: null,
            languageId: null,
            ...initialValues,
        },
        {
            validation,
            valuesToInput: values => values,
        },
    );
};

export default useQuotationCardFormState;
